import React from 'react';
import { CaretDownIcon, CaretUpIcon } from '@udacity/chakra-uds-icons';

interface TableSortArrowsProps {
  isActive: boolean;
  isAscending: boolean;
}

export const TableSortArrows: React.FC<TableSortArrowsProps> = ({ isActive, isAscending }) => {
  return isAscending ? (
    <CaretDownIcon color={isActive ? 'blue.700' : 'gray.500'} w={6} h={6} />
  ) : (
    <CaretUpIcon color={isActive ? 'blue.700' : 'gray.500'} w={6} h={6} />
  );
};
